/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ref_N7Inputs */

const en_viewer_ref_n7 = /** @type {(inputs: Viewer_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Array elements use bracketed indices, so the path reads as a real accessor.`)
};

const ko_viewer_ref_n7 = /** @type {(inputs: Viewer_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열 요소는 대괄호 인덱스를 쓰므로 경로가 실제 접근자처럼 읽힙니다.`)
};

const ja_viewer_ref_n7 = /** @type {(inputs: Viewer_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列要素は角かっこの添字を使うので、パスが実際のアクセサとして読めます。`)
};

/**
* | output |
* | --- |
* | "Array elements use bracketed indices, so the path reads as a real accessor." |
*
* @param {Viewer_Ref_N7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ref_n7 = /** @type {((inputs?: Viewer_Ref_N7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ref_N7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ref_n7(inputs)
	if (locale === "ko") return ko_viewer_ref_n7(inputs)
	return ja_viewer_ref_n7(inputs)
});